<div class="autocomplete">
  <div class="input-icon">
    <input [(ngModel)]="searchTerm" type="text" class="form-control" placeholder="{{placeholder || 'Pretraži'}}" (keyup)="getProducts()">
    <div class="input-icon-addon">
      <i class="fe fe-search"></i>
    </div>
  </div>

  <div class="autocomplete__list" *ngIf="isListVisible">
    <div class="autocomplete__item" *ngFor="let product of products" [ngClass]="{'disabled disabled--faded': isSelectedProduct(product)}" (click)="onSelect(product)">
      <div>
        {{ product.articleCode ? product.articleCode + ' - ' : '' }}{{ product.name }}
      </div>
    </div>
  </div>
</div>